{
  "slug": "iq-vs-sat",
  "title": "IQ vs SAT",
  "description": "The tests overlap in some reasoning demands but differ in purpose, content, preparation, scaling, and interpretation.",
  "category": "Comparisons",
  "sections": [
    {
      "heading": "Purpose",
      "paragraphs": [
        "The tests overlap in some reasoning demands but differ in purpose, content, preparation, scaling, and interpretation.",
        "Begin with purpose rather than asking which score is universally better."
      ]
    },
    {
      "heading": "Measurement differences",
      "paragraphs": [
        "Compare content, limits, norms, reliability, validity, preparation, and decision rules.",
        "Correlation does not make measures interchangeable."
      ]
    },
    {
      "heading": "What to use",
      "paragraphs": [
        "Use evidence validated for the question. Admissions, clinical evaluation, grades, creativity, and emotion need different evidence.",
        "Do not convert scores without a justified publisher method."
      ]
    }
  ],
  "related": ["iq-vs-intelligence", "iq-vs-eq", "how-is-iq-measured"],
  "sources": [],
  "faqs": [],
  "summary": "The tests overlap in some reasoning demands but differ in purpose, content, preparation, scaling, and interpretation. Content reviewed 18 July 2026."
}
